import React from "react";
import PropTypes from "prop-types";
import {component_tool} from "../../../tool";
import {AudienceGroupItem} from '@/components';
import WizTableForm from "../wizTableForm/wizTableForm";
import {isEqual} from '@/utils';

import WizOrgSelect from "./wizOrgSelect";
import WizPersonSelect from "./wizPersonSelect";


const {WizComponent, WizAntdForm, WizRow, WizCol, WizRadio, WizModal, WizButton, WizDataTable} = component_tool;
const {Item} = WizAntdForm;

class WizDataAuthSelect extends WizComponent {
  componentName = "WizDataAuthSelect";

  constructor(props) {
    super(props);
    this.state = {
      orgImportVisible: false,
      personImportVisible: false,
      defaultCheckValue: props.hasRadioGroup !== undefined && !props.hasRadioGroup ? 0 : 1,
      time: new Date().getTime(),
      scope: {},
      visibleForGroup: false,
      initRows: {}
    };

  }

  _initRows = (props) => {
    if (this.flag) return;

    const _values = JSON.parse(JSON.stringify(this.props.value))
    delete _values.groupId
    const filterValues = Object.values(_values).filter(val => val && val.length > 0)
    if (!this.props.value.groupId && filterValues.length) {
      this.setState({defaultCheckValue: 0})
    }
    this.setState({initRows: this.props.value})
  }

  componentWillMount() {
    this.flag = false
    this._initRows()
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (!isEqual(nextProps.value, this.props.value)) {
      const _values = JSON.parse(JSON.stringify(nextProps.value))
      delete _values.groupId
      const filterValues = Object.values(_values).filter(val => val && val.length > 0)
      if (!nextProps.value.groupId && filterValues.length) {
        this.setState({defaultCheckValue: 0})
      }
      this.setState({initRows: nextProps.value})
    }
  }

  /**
   * 参数校验
   */
  static propTypes = {
    onChange: PropTypes.func, //参数变化时反馈数据的方法
    value: PropTypes.object, //初始化的默认值
  };

  propsAndStateOnChange = {
    value: this._value.bind(this),
  };

  /**
   * 监控value变化，进行渲染
   */
  _value(nextProps, nextState) {
    nextState["time"] = new Date().getTime();
    return true;
  }

  handleCheckboxOnChange = (e) => {
    // const { initRows } = this.state
    // const { onChange } = this.props
    // const _initRows = {}
    // if(e.target.value === 1) {
    //   _initRows.groupId = initRows.groupId
    // } else {
    //   _initRows.orgIds = initRows.orgIds
    //   _initRows.personIds = initRows.personIds
    //   _initRows.positionCategoryIds = initRows.positionCategoryIds
    //   _initRows.positionIds = initRows.positionIds
    // }
    // console.log('_initRows', _initRows)
    // onChange && onChange(_initRows)
    this.setState({defaultCheckValue: e.target.value, time: new Date().getTime()});
  };

  /**
   * 值变化提交
   */
  _onSelect = (key, e) => {
    const {defaultCheckValue, initRows} = this.state
    const {onChange} = this.props;
    const values = Object.values(e);

    this.setState({initRows: values});

    const _data = initRows

    if (defaultCheckValue === 1) {
      const _groupId = values[0] || {}
      const groupScope = _groupId.groupScope || {}
      delete groupScope.isAll
      delete _groupId.groupScope
      groupScope.groupId = [_groupId]
      _data[key] = groupScope.groupId
      _data.orgIds = groupScope.orgIds
      _data.personIds = groupScope.personIds
      _data.positionCategoryIds = groupScope.positionCategoryIds
      _data.positionIds = groupScope.positionIds
      this.setState({initRows: groupScope, groupId: groupScope.groupId, time: new Date().getTime()})
    } else {
      _data[key] = values
      delete _data.groupId
      delete _data.isAll
      this.setState({initRows: _data})
    }
    onChange && onChange(_data);
  };

  // 查看受众
  handleLook = (e, text) => {
    e.stopPropagation()
    this.setState({visibleForGroup: true, scope: text})
  }

  /**
   *  渲染选择组件
   */
  _select = (key, title, Config = {}, placeholder) => {
    let {value, ...other} = this.props;
    const {initRows} = this.state;
    let _initRows = [];
    if (Array.isArray(initRows[key])) {
      _initRows = initRows[key]
    } else if (Object.prototype.toString.call(initRows[key]) === '[object Object]') {
      _initRows = [initRows[key]]
    }

    const initProps = {
      initRows: _initRows,
      value: _initRows && _initRows.map((val) => val.id),
    };

    return (
      <Item label={title} labelCol={{span: 4}} wrapperCol={{span: 15}}>
        <WizCol span={22}>
          <WizTableForm
            key={key + "@" + this.state.time}
            {...Config}
            onChangeRowMap={(e) => this._onSelect(key, e)}
            {...initProps}
            {...other}
          />
        </WizCol>
        {key == 'orgIds' ? <WizCol span={2}>
          <WizDataTable.Oper>
            <WizButton onClick={e => this._selectOrgIds()}>
              导入组织
            </WizButton>
          </WizDataTable.Oper></WizCol> : <></>
        }
        {key == 'personIds' ? <WizCol span={2}>
          <WizDataTable.Oper>
            <WizButton onClick={e => this._selectPersonIds()}>
              导入人员
            </WizButton>
          </WizDataTable.Oper></WizCol> : <></>
        }
      </Item>
    );
  };

  renderItem = () => {
    const {defaultCheckValue} = this.state;
    const {isNotAuth = false} = this.props;
    const arr = []

    let args = {};
    if (isNotAuth) {
      args['isNotAuth'] = true;
    }

    if (defaultCheckValue === 0) {
      arr.push(this._select("orgIds", "组织选择", {
        allowTreeSelect: true,
        ...arr,
        ...WizTableForm.Config.organization(this, {state: 1, apiParams: {...args}})
      }))
      arr.push(this._select(
        "positionIds",
        "岗位选择",
        WizTableForm.Config.position(this, {apiParams: {...args}})
      ))
      arr.push(this._select(
        "positionCategoryIds",
        "岗位分类",
        WizTableForm.Config.positionCategory(this, {apiParams: {...args}})
      ))
      arr.push(this._select(
        "personIds",
        "指定人员",
        WizTableForm.Config.user(this, {apiParams: {...args}})
      ))
      return arr
    }

    arr.push(this._select(
      "groupId",
      "选择组",
      {
        ...WizTableForm.Config.audienceGroup(this, {}),
        selectType: 'radio',
        placeholder: '请选择组'
      }
    ))

    return arr
  }

  _selectOrgIds = () => {

    this.setState({orgImportVisible: true, personImportVisible: false})
  }

  _selectPersonIds = () => {

    this.setState({orgImportVisible: false, personImportVisible: true})
  }

  render() {
    const {defaultCheckValue, visibleForGroup, scope, orgImportVisible, personImportVisible, initRows, time} = this.state;

    const {onChange, hasRadioGroup, modalKey, isNotAuth = false} = this.props;
    const modalProps = {
      title: '查看受众组',
      visible: visibleForGroup,
      footer: null,
      onCancel: () => {
        this.setState({visibleForGroup: false})
      }
    }

    return (
      <React.Fragment>
        {
          hasRadioGroup === undefined || hasRadioGroup ? <WizRow style={{marginBottom: 24}}>
            <WizCol span={4} style={{textAlign: "right"}}></WizCol>
            <WizCol span={15}>
              <WizRadio.Group
                style={{marginLeft: -70}}
                onChange={this.handleCheckboxOnChange}
                value={defaultCheckValue}
              >
                <WizRadio value={1}>组</WizRadio>
                <WizRadio value={0}>自主选择</WizRadio>
              </WizRadio.Group>
            </WizCol>
          </WizRow> : null
        }

        {this.renderItem()}

        <WizModal {...modalProps}>
          <AudienceGroupItem {...scope} />
        </WizModal>
        <WizModal title={"组织导入"}
                  visible={orgImportVisible}
                  footer={null}
                  destroyOnClose={true}
                  onCancel={() => {
                    this.setState({orgImportVisible: false, personImportVisible: false})
                  }}
                  onOk={() => {
                    this.setState({orgImportVisible: false, personImportVisible: false})
                  }}
        >

          <WizOrgSelect modalKey={modalKey} isNotAuth={isNotAuth} callback={(data) => {
            const {defaultCheckValue, initRows} = this.state
            let xxx = []
            initRows?.orgIds?.forEach(item => {
              xxx.push(item)
            })
            if (data && data instanceof Array && data.length > 0) {
              data.forEach(dat => {
                let initRow = initRows?.orgIds?.filter(item => item?.id == dat?.id)
                if (!initRow?.length) {
                  xxx.push(dat)
                }
              })
            }
            const {onChange} = this.props;
            const values = Object.values(xxx);
            this.setState({initRows: values});

            const _data = initRows
            if (defaultCheckValue === 1) {
              const _groupId = values[0] || {}
              const groupScope = _groupId.groupScope
              delete groupScope.isAll
              delete _groupId.groupScope
              groupScope.groupId = [_groupId]
              _data['orgIds'] = groupScope.groupId
              _data.orgIds = groupScope.orgIds
              _data.personIds = groupScope.personIds
              _data.positionCategoryIds = groupScope.positionCategoryIds
              _data.positionIds = groupScope.positionIds
              this.setState({initRows: groupScope, groupId: groupScope.groupId, time: new Date().getTime()})
            } else {
              _data['orgIds'] = values
              delete _data.groupId
              delete _data.isAll
              this.setState({initRows: _data, time: new Date().getTime()})
            }
            onChange && onChange(_data);

          }}
          />
        </WizModal>

        <WizModal title={"人员导入"}
                  visible={personImportVisible}
                  destroyOnClose={true}
                  footer={null}
                  onCancel={() => {
                    this.setState({orgImportVisible: false, personImportVisible: false})
                  }}
                  onOk={() => {
                    this.setState({orgImportVisible: false, personImportVisible: false})
                  }}
        >

          <WizPersonSelect modalKey={time} callback={(data) => {
            const {defaultCheckValue, initRows} = this.state
            let xxx = []
            initRows?.personIds?.forEach(item => {
              xxx.push(item)
            })
            if (data && data instanceof Array && data.length > 0) {
              data.forEach(dat => {
                let initRow = initRows?.personIds?.filter(item => item?.id == dat?.id)
                if (!initRow?.length) {
                  xxx.push(dat)
                }
              })
            }
            const {onChange} = this.props;
            const values = Object.values(xxx);
            this.setState({initRows: values});

            const _data = initRows
            if (defaultCheckValue === 1) {
              const _groupId = values[0] || {}
              const groupScope = _groupId.groupScope
              delete groupScope.isAll
              delete _groupId.groupScope
              groupScope.groupId = [_groupId]
              _data['orgIds'] = groupScope.groupId
              _data.orgIds = groupScope.orgIds
              _data.personIds = groupScope.personIds
              _data.positionCategoryIds = groupScope.positionCategoryIds
              _data.positionIds = groupScope.positionIds
              this.setState({initRows: groupScope, groupId: groupScope.groupId, time: new Date().getTime()})
            } else {
              _data['personIds'] = values
              delete _data.groupId
              delete _data.isAll
              this.setState({initRows: _data, time: new Date().getTime()})
            }
            onChange && onChange(_data);
          }}
          />
        </WizModal>
      </React.Fragment>
    );
  }
}

// const mapStateToProps = (state, ownProps) => {
//   return {};
// };

// const options = { withRef: true };

export default WizDataAuthSelect
